import React from 'react';
import './WhoWeAreSection.css';
import greenBullet from '../../assets/images/green-bullet.svg';

const WhoWeAreSection = () => {
  return (
    <section className="who-we-are-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-label">
            <img src={greenBullet} alt="" className="bullet-image" />
            WHO WE ARE
          </h2>
          <h3 className="section-headline">
            A private equity firm with an unrelenting focus on modernization
          </h3>
          <p className="section-description">
            BayPine aims to pioneer a new category of private equity - digital transformation capital - to drive innovation and sustainable growth in core-economy, market-leading businesses.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhoWeAreSection;